import React from 'react';

import { Control } from 'react-hook-form';

import { Button, Stack, TableCell, TableRow, Typography } from '@mui/material';

import TextFieldControlled from 'components/shared/TextFieldControlled';

import type RefundForm from '../../../models/RefundForm';
import type RefundLineItem from '../../../models/RefundLineItem';

interface RowProps {
    index: number;
    item: RefundLineItem;
    control: Control<RefundForm>;
    onRemove: VoidFunction;
}

const RefundItemRow: React.FC<RowProps> = ({
    index,
    item,
    control,
    onRemove,
}) => (
    <TableRow>
        <TableCell>
            <Stack flexDirection="row" alignItems="center" gap={1}>
                <img
                    height={80}
                    width={80}
                    style={{ objectFit: 'contain' }}
                    src={item.image !== '' ? item.image : 'assets/empty.png'}
                />
                <Typography>{item.description}</Typography>
            </Stack>
        </TableCell>
        <TableCell>
            <Typography>{item.documentNo}</Typography>
        </TableCell>
        <TableCell>
            <Typography>{item.shippedQtyNotReturned}</Typography>
        </TableCell>
        <TableCell>
            <TextFieldControlled
                control={control}
                name={`products.${index}.quantity`}
                type="number"
                minValue={1}
                maxValue={+item.shippedQtyNotReturned}
            />
        </TableCell>
        <TableCell>
            <Typography>{item.unitOfMeasureCode}</Typography>
        </TableCell>
        <TableCell>
            <Button color="error" onClick={onRemove}>
                <Typography variant="caption" textTransform="uppercase">
                    Törlés
                </Typography>
            </Button>
        </TableCell>
    </TableRow>
);

export default RefundItemRow;
